/**
 * @flow
 * @relayHash f9887f94e6feeebc3db345acc2c7b6ce
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ResetPasswordCompleteQueryVariables = {||};
export type ResetPasswordCompleteQueryResponse = {|
  +viewer: ?{|
    +id: string
  |}
|};
export type ResetPasswordCompleteQuery = {|
  variables: ResetPasswordCompleteQueryVariables,
  response: ResetPasswordCompleteQueryResponse,
|};
*/


/*
query ResetPasswordCompleteQuery {
  viewer {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "Query",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ResetPasswordCompleteQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ResetPasswordCompleteQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ResetPasswordCompleteQuery",
    "id": null,
    "text": "query ResetPasswordCompleteQuery {\n  viewer {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '966f45a3b5463665b9a0a22d0159510f';
module.exports = node;
